import {Fragment} from "react";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import React from "react";
import Box from "../../../layout/Box";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const List = props.list || Box;
    return <List
        key={1}
        boxid={propsTop.boxid}
        theme="default"
        collapsed={propsTop.hasOwnProperty('collapsed') ? propsTop.collapsed : true}
        header={<Fragment>Mentett listák {state.count && state.count > 0 && <span className="badge">{state.count} db</span>}</Fragment>}
    >
        <SelectorGrid
            ref={(el) => parent.componentList = el}
            componentConfig={props.componentConfig}
            view="list"
            onLoadCompleted={(data) => props.setState({count: data.fullcount})}
            columns={props.columns}
            pageSize={5}
            filter={props.filter}
            orderBy={{field: props.componentConfig.idfield, direction: "DESC"}}
            onSelectionChange={(selection) => props.loadForm(selection.value)}
            selection={props.selection}
        />
    </List>
}